module.exports = __webpack_public_path__ + "static/storm_giant_ladies_plays-f30520f544023f51f966f8ef34a91e70.jpg";